import { useQuery } from '@tanstack/react-query'
import { fetchBannersFromApi } from '@core/Components/Banner/helpers/api'
import { queryKeys } from '@core/Data/ReactQuery/constants'

const FALLBACK_MESSAGE = 'WHAT ARE YOU REALLY GAMBLING WITH?'

export const useResponsibleWageringMessage = () => {
  const { isError, isLoading, data } = useQuery({
    queryKey: [queryKeys.banner],
    queryFn: fetchBannersFromApi,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  })

  if (isError || isLoading) return FALLBACK_MESSAGE

  const firstResponsibleWageringBanner = data?.find(banner =>
    banner.ResponsibleWageringText?.trim()
  )

  return (
    firstResponsibleWageringBanner?.ResponsibleWageringText?.trim().toUpperCase() ||
    FALLBACK_MESSAGE
  )
}
